import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../hooks/useUser';
import { LoginItem } from '../../components/Login';
import { SignUpItem } from '../../components/SignupButton';
import { LogoutItem } from '../../components/LogoutButton';
import SettingsButton from './SettingsButton';

interface TopBarProps {
  title?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
  middleContent?: React.ReactNode;
}

const TopBar: React.FC<TopBarProps> = ({ 
  title, 
  showBackButton = false,
  onBackClick,
  middleContent
}) => {
  const navigate = useNavigate();
  const user = useUser();
  const loggedIn = user.state === "LoggedIn";

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 px-4 py-4 border-b w-full bg-[var(--rhea-bg-primary)] z-10" 
         style={{ borderColor: 'var(--rhea-card-border)' }}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          {showBackButton && (
            <button
              onClick={handleBackClick}
              className="p-2 rounded-lg hover:opacity-80 transition-opacity"
              style={{ 
                backgroundColor: 'var(--rhea-bg-tertiary)',
                color: 'var(--rhea-text-secondary)'
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
            </button>
          )}
          <div className="flex items-center gap-4 cursor-pointer" onClick={handleLogoClick}>
            <img src="/assets/rhea/logo.png" alt="Rhea" className="h-10" />
          </div>
          {title && (
            <h1 
              className="text-2xl font-semibold"
              style={{ color: 'var(--rhea-text-primary)' }}
            >
              {title}
            </h1>
          )}
        </div>

        {/* Middle Content */}
        {middleContent && (
          <div className="flex-1 flex justify-center">
            {middleContent}
          </div>
        )}

        {/* Auth Buttons */}
        <div className="flex items-center gap-2">
          {!loggedIn ? (
            <>
              <LoginItem title="Login to ThoughtfulOasis" className="px-3 py-1 rounded-lg text-sm whitespace-nowrap border border-[var(--rhea-card-border)] text-[var(--rhea-text-secondary)] hover:bg-[var(--rhea-card-hover)]"/>
              <SignUpItem title="Sign up for ThoughtfulOasis" className="px-3 py-1 rounded-lg text-sm whitespace-nowrap border border-[var(--rhea-accent-primary)] text-[var(--rhea-accent-primary)] hover:bg-[var(--rhea-card-hover)]"/>
            </>
          ) : (
            <>
              <SettingsButton />
              <LogoutItem className="px-3 py-1 rounded-lg text-sm whitespace-nowrap border border-[var(--rhea-card-border)] text-[var(--rhea-text-secondary)] hover:bg-[var(--rhea-card-hover)]"/>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar; 